import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import { saveCustomer } from "../../actions/CustomerActions";
import { styleSelect } from "../../constants/customStyles";
import Select from 'react-select';
import { getVehicleReplacementById, saveFromDriver, updateVehicleReplacement } from "../../actions/VehicleReplacementsActions";
import Dropzone, { useDropzone } from 'react-dropzone';
import SignatureCanvas from 'react-signature-canvas'
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Scrollbar } from "swiper";
import Mobilemenu from "../../layouts/mobile-menu";

function ReplacementForm() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        dispatch(getVehicleReplacementById(params.id))
    }, [params.id])

    const vehicleReplacement = useSelector(state => state?.vehicleReplacements?.vehicleReplacement);
    const loading = useSelector(state => state?.loading?.loading);

    const [replaceVehicleIn, setReplaceVehicleIn] = useState('');
    const [replaceVehicleOut, setReplaceVehicleOut] = useState('');
    const [customerVehicleIn, setCustomerVehicleIn] = useState('');
    const [customerVehicleOut, setCustomerVehicleOut] = useState('');
    const [activeAccordionItem, setActiveAccordionItem] = useState();
    // const [formData, setFormData] = useState({});

    useEffect(() => {
        if (vehicleReplacement && vehicleReplacement.replace_vehicle_status) {
            const replaceVehicleStatus = vehicleReplacement.replace_vehicle_status;

            if (replaceVehicleStatus.length > 0) {
                const latestStatus = replaceVehicleStatus[replaceVehicleStatus.length - 1];
                setActiveAccordionItem(latestStatus.replace_vehicle_status_id);
            } else {
                setActiveAccordionItem(1);
            }
        }
    }, [vehicleReplacement]);

    const saveReplaceVehicleIn = async () => {
        if (!replaceVehicleIn.replaced_vehicle_fuel_in) {
            Toast.fire({
                icon: 'error',
                title: 'Replaced Vehicle Fuel In is Required!'
            })
        } else if (!replaceVehicleIn.replaced_vehicle_km_in) {
            Toast.fire({
                icon: 'error',
                title: 'Replaced Vehicle Km In is Required!'
            })
        }
        else {
            let data = {
                replaceVehicleIn: replaceVehicleIn,
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in files) {
                formData1.append('images[]', files[key])
            }
            await dispatch(saveFromDriver(formData1, params.id, navigate));
            setFiles([])
            dispatch(getVehicleReplacementById(params.id));
        }
    }
    const saveReplaceVehicleOut = async () => {
        if (!replaceVehicleOut.replaced_vehicle_km_out) {
            Toast.fire({
                icon: 'error',
                title: 'Replaced Vehicle Km Out is Required!'
            })
        } else if (!replaceVehicleOut.replaced_vehicle_fuel_out) {
            Toast.fire({
                icon: 'error',
                title: 'Replaced Vehicle Fuel Out is Required!'
            })
        }
        else {
            let data = {
                replaceVehicleOut: replaceVehicleOut,
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in files) {
                formData1.append('images[]', files[key])
            }
            await dispatch(saveFromDriver(formData1, params.id, navigate));
            setFiles([])
            dispatch(getVehicleReplacementById(params.id));
        }
    }
    const saveCustomerVehicleIn = async () => {
        if (!customerVehicleIn.km_in) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Vehicle Km In is Required!'
            })
        } else if (!customerVehicleIn.fuel_in) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Vehicle Fuel In is Required!'
            })
        }
        else {
            let data = {
                customerVehicleIn: customerVehicleIn,
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in files) {
                formData1.append('images[]', files[key])
            }
            await dispatch(saveFromDriver(formData1, params.id, navigate));
            setFiles([])
            dispatch(getVehicleReplacementById(params.id));
        }
    }
    const saveCustomerVehicleOut = async () => {
        if (!customerVehicleOut.km_out) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Vehicle Km Out is Required!'
            })
        } else if (!customerVehicleOut.fuel_out) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Vehicle Fuel Out is Required!'
            })
        }
        else {
            let data = {
                customerVehicleOut: customerVehicleOut
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in files) {
                formData1.append('images[]', files[key])
            }
            await dispatch(saveFromDriver(formData1, params.id, navigate));
            setFiles([])
            dispatch(getVehicleReplacementById(params.id));
        }
    }
    const handleChangeKmIn = (event) => {
        setCustomerVehicleIn({
            ...customerVehicleIn,
            [event.target.name]: event.target.value,
        });
    };
    const handleChangeKmOut = (event) => {
        setCustomerVehicleOut({
            ...customerVehicleOut,
            [event.target.name]: event.target.value,
        });
    };
    const handleChangeReplaceVehicleKmIn = (event) => {
        setReplaceVehicleIn({
            ...replaceVehicleIn,
            [event.target.name]: event.target.value,
        });
    };
    const handleChangeReplaceVehicleKmOut = (event) => {
        setReplaceVehicleOut({
            ...replaceVehicleOut,
            [event.target.name]: event.target.value,
        });
    };

    const handleChangeFuelInOption = (e) => {
        // e)
        setCustomerVehicleIn({
            ...customerVehicleIn,
            fuel_in: e.value,
            fuel_id: e.label,
        });
    };
    const handleChangeFuelOutOption = (e) => {
        // e)
        setCustomerVehicleOut({
            ...customerVehicleOut,
            fuel_out: e.value,
            fuel_out_id: e.label,
        });
    };
    const handleChangeReplacedVehicleFuelInOption = (e) => {
        // e)
        setReplaceVehicleIn({
            ...replaceVehicleIn,
            replaced_vehicle_fuel_in: e.value,
            replaced_vehicle_fuel_in_id: e.label,
        });
    };
    const handleChangeReplacedVehicleFuelOutOption = (e) => {
        // e)
        setReplaceVehicleOut({
            ...replaceVehicleOut,
            replaced_vehicle_fuel_out: e.value,
            replaced_vehicle_fuel_out_id: e.label,
        });
    };
    const signatureRef = useRef(null);
    const clearCanvas = () => {
        signatureRef.current.clear(); // Clear the canvas
    };

    const getReplaceVehicleSignatureAsBase64 = () => {
        if (signatureRef.current) {
            const base64Data = signatureRef.current.getTrimmedCanvas().toDataURL(); // Get base64 data
            setReplaceVehicleOut({
                ...replaceVehicleOut,
                remarks: base64Data,
            });
        } else {
            console.error("SignatureCanvas is not available yet.");
        }
    };
    const getCustomerVehicleSignatureAsBase64 = () => {
        if (signatureRef.current) {
            const base64Data = signatureRef.current.getTrimmedCanvas().toDataURL(); // Get base64 data
            setCustomerVehicleIn({
                ...customerVehicleIn,
                remarks: base64Data,
            });
        } else {
            console.error("SignatureCanvas is not available yet.");
        }
    };
    const FuelOptions = [
        { label: 'F', value: 'F' },
        { label: '1/3', value: '1/3' },
        { label: '1/2', value: '1/2' },
        { label: '3/4', value: '3/4' },
        { label: 'E', value: 'E' },
    ]
    const [files, setFiles] = useState([]);
    const thumbsContainer = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 16
    };

    const thumb = {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 15,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box'
    };

    const thumbInner = {
        display: 'block',
        minWidth: 92,
        overflow: 'hidden'
    };

    const img = {
        display: 'block',
        width: 'auto',
        height: '100%'
    };

    const { getRootProps, getInputProps } = useDropzone({
        accept: '.jpeg,.png,.jpg',
        maxFiles: 30,
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (files && files.length < 1) {
                setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + files.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const removeImage = (file, index) => {
        if (!Array.isArray(files) || files.length === 0) {
            console.error('Invalid files array:', files);
            return;
        }

        const updatedFiles = [...files];

        if (index >= 0 && index < updatedFiles.length) {
            if (index === 0 && updatedFiles.length > 1 && updatedFiles[0].default === 1) {
                updatedFiles[1].default = 1;
            }

            updatedFiles.splice(index, 1);
            setFiles(updatedFiles);
        } else {
            console.error('Invalid index:', index);
        }
    };

    
    const [dropzoneTitle, setDropZoneTitle] = useState("Please Upload Photos");
    const thumbs =
        files && files.length > 0 ? (
            files.map((file, index) => (
                <React.Fragment key={index + 1}>
                    <SwiperSlide>
                        <div>
                            <div style={thumb} className={`${file.default === 1 ? "default-image" : ""}`} key={file.name}>
                                <div style={thumbInner}>
                                    <img src={file.preview} style={img} alt={`Preview ${index + 1}`} />
                                </div>
                            </div>
                            <span className="image-close" onClick={() => removeImage(file, index)}>
                                &times;
                            </span>
                        </div>
                    </SwiperSlide>
                </React.Fragment>
            ))
        ) : (
            ''
        );


    // 'files', Object.keys(files).length)

    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center my-2 mt-5">
                        <h2 className="fs-base ms-3 fw-medium me-auto">
                            Customer Info
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-3">
                        <div className="intro-y g-col-12">
                            {/* <!-- BEGIN: Form Layout --> */}
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Customer Name :</label>
                                        <input id="name" name="name" disabled value={vehicleReplacement?.customer?.name} type="text" className="form-control" placeholder="Enter Customer Name" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="mobile" className="form-label">Customer Mobile Number :</label>
                                        <input id="mobile" name="mobile" disabled value={vehicleReplacement?.customer?.mobile} type="text" className="form-control" placeholder="Enter Customer Mobile Number" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid columns-12 mt-3">
                        <div className="intro-y g-col-12 g-col-sm-6">
                            <div className="intro-y d-flex align-items-center my-2 mb-3">
                                <h2 className="fs-base ms-3 fw-medium me-auto">
                                    Customer Vehicle
                                </h2>
                            </div>
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="chasisNo" className="form-label">Chasis No. :</label>
                                        <input disabled id="chasisNo" name="chasisNo" type="text" value={vehicleReplacement?.vehicle?.chasis_no} className="form-control" placeholder="Enter Chasis No." />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="plateNo" className="form-label">Plate No. :</label>
                                        <input disabled id="plateNo" name="plateNo" type="text" value={vehicleReplacement?.vehicle?.plate_number} className="form-control" placeholder="Enter Plate No." />
                                    </div>
                                    {/* <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="kmIn" className="form-label">Km In :</label>
                                        <input id="kmIn" name="kmIn" onChange={(e) => setKmIn(e.target.value)} type="text" className="form-control" placeholder="Km In" />
                                    </div>
                                    <div className="g-col-12 g-col-md-6">
                                        <label for="crud-form-1" className="form-label">Fuel <span className="text-theme-6">*</span> :</label>
                                        <Select styles={styleSelect} options={FuelOptions} onChange={(e) => handleChangeFuelOption(e)} />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="intro-y g-col-12 g-col-sm-6">
                            <div className="intro-y g-col-12 g-col-sm-6">
                                <div className="intro-y d-flex align-items-center my-2 mb-3">
                                    <h2 className="fs-base ms-3 fw-medium me-auto">
                                        Replaced Vehicle
                                    </h2>
                                </div>
                                <div className="intro-y box p-5">
                                    <div className="grid columns-12">
                                        <div className="intro-y g-col-12 g-col-sm-6">
                                            <label for="chasisNo" className="form-label">Chasis No. :</label>
                                            <input disabled id="chasisNo" name="chasisNo" type="text" value={vehicleReplacement?.replaceable_vehicle?.chasis_no} className="form-control" placeholder="Enter Chasis No." />
                                        </div>
                                        <div className="intro-y g-col-12 g-col-sm-6">
                                            <label for="plateNo" className="form-label">Plate No. :</label>
                                            <input disabled id="plateNo" name="plateNo" type="text" value={vehicleReplacement?.replaceable_vehicle?.plate_number} className="form-control" placeholder="Enter Plate No." />
                                        </div>
                                        {/* <div className="intro-y g-col-12 g-col-sm-6">
                                            <label for="kmOut" className="form-label">Km Out :</label>
                                            <input id="kmOut" name="kmOut" type="text" onChange={(e) => setReplacedVehicleKmOut(e.target.value)} className="form-control" placeholder="Km Out" />
                                        </div>
                                        <div className="g-col-12 g-col-md-6">
                                            <label for="crud-form-1" className="form-label">Fuel <span className="text-theme-6">*</span> :</label>
                                            <Select styles={styleSelect} options={FuelOptions} onChange={(e) => handleChangeReplacedFuelOption(e)} />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="faq-accordion-2" class="accordion accordion-boxed mt-3">
                        {
                            activeAccordionItem == 1 || activeAccordionItem == 10 ?
                                <div class="accordion-item box">
                                    <div id="faq-accordion-content-1" class="accordion-header"> <button class={`accordion-button fs-lg ${activeAccordionItem == 1 || activeAccordionItem == 10 ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-5" aria-expanded="true" aria-controls="faq-accordion-collapse-5"> {activeAccordionItem == 1 ? 'Replaced Vehicle Info on Pickup' : 'Customer Vehicle Info on Pickup'} </button> </div>
                                    <div id="faq-accordion-collapse-5" class={`accordion-collapse collapse ${activeAccordionItem == 1 || activeAccordionItem == 10 ? "show" : ''}`} aria-labelledby="faq-accordion-content-1" data-bs-parent="#faq-accordion-2">
                                        <div class="accordion-body lh-lg">
                                            <div className="grid columns-12">
                                                <div className="intro-y g-col-12 g-col-md-6">
                                                    <label for="replaced_vehicle_km_in" className="form-label">Km In <span className="text-theme-6">*</span> :</label>
                                                    <input id="replaced_vehicle_km_in" value={replaceVehicleIn?.replaced_vehicle_km_in} name="replaced_vehicle_km_in" onChange={handleChangeReplaceVehicleKmIn} type="text" className="form-control" placeholder="Km In" />
                                                    <label for="crud-form-1" className="form-label mt-3">Fuel In <span className="text-theme-6">*</span> :</label>
                                                    <Select styles={styleSelect} value={{ label: replaceVehicleIn?.replaced_vehicle_fuel_in, value: replaceVehicleIn?.replaced_vehicle_fuel_in }} options={FuelOptions} id="repalcedVehicleFuelId" name="replacedVehicleFuelIn" onChange={(e) => handleChangeReplacedVehicleFuelInOption(e)} />
                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="image" className="form-label">Image<span className="text-theme-6">*</span> :</label>
                                                    <section className="text-center form-control w-full">
                                                        <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                            {
                                                                (files && files.length == 0) &&
                                                                <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                            }
                                                        </aside>
                                                        <Swiper
                                                            slidesPerView={5}
                                                            scrollbar={{
                                                                hide: true,
                                                            }}
                                                            grid={{
                                                                rows: 1,
                                                            }}
                                                            modules={[Grid, Scrollbar]}
                                                            className="mySwiper h-full"
                                                        >
                                                            {thumbs}
                                                        </Swiper>
                                                        <div {...getRootProps({
                                                            className: 'dropzone p-3'
                                                        })}>
                                                            <input {...getInputProps()} />
                                                            <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                            <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                        </div>
                                                    </section>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        {/* <div class="d-flex flex-column mt-2">
                                                        <div class="form-check me-2"> <input id="checkbox-switch-4" class="form-check-input" type="checkbox" value="" /> <label class="form-check-label" for="checkbox-switch-4">Spare Wheel</label> </div>
                                                        <div class="form-check me-2 mt-2 mt-sm-0"> <input id="checkbox-switch-5" class="form-check-input" type="checkbox" value="" /> <label class="form-check-label" for="checkbox-switch-5">Job In</label> </div>
                                                    </div> */}
                                                        {/* <div>
                                                    <button className="btn w-48 btn-primary mt-3">Photos</button>
                                                </div> */}
                                                    </div>
                                                </div>
                                                <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                                    <button className="btn btn-outline-secondary w-24">Cancel</button>
                                                    <button onClick={saveReplaceVehicleIn} disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                        {
                            activeAccordionItem == 2 || activeAccordionItem == 11 ?
                                <div class="accordion-item box">
                                    <div id="faq-accordion-content-2" class="accordion-header"> <button class={`accordion-button fs-lg ${activeAccordionItem == 2 || activeAccordionItem == 11 ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-6" aria-expanded="false" aria-controls="faq-accordion-collapse-6"> {activeAccordionItem == 2 ? 'Replaced Vehicle Info Before Giving To Customer' : 'Customer Vehicle Info Before Giving To Customer'} </button> </div>
                                    <div id="faq-accordion-collapse-6" class={`accordion-collapse collapse ${activeAccordionItem == 2 || activeAccordionItem == 11 ? "show" : ''}`} aria-labelledby="faq-accordion-content-2" data-bs-parent="#faq-accordion-2">
                                        <div class="accordion-body lh-lg">
                                            <div className="grid columns-12">
                                                <div className="intro-y g-col-12 g-col-md-6">
                                                    <label for="replaced_vehicle_km_out" className="form-label">Km Out <span className="text-theme-6">*</span> :</label>
                                                    <input id="replaced_vehicle_km_out" name="replaced_vehicle_km_out" value={replaceVehicleOut?.replaced_vehicle_km_out} onChange={handleChangeReplaceVehicleKmOut} type="text" className="form-control" placeholder="Km Out" />
                                                    <label for="crud-form-1" className="form-label mt-3">Fuel Out <span className="text-theme-6">*</span> :</label>
                                                    <Select styles={styleSelect} className="z-50" value={{ label: replaceVehicleOut?.replaced_vehicle_fuel_out, value: replaceVehicleOut?.replaced_vehicle_fuel_out }} options={FuelOptions} id="repalcedVehicleFuelId" name="replacedVehicleFuelOut" onChange={(e) => handleChangeReplacedVehicleFuelOutOption(e)} />
                                                    <label for="image" className="form-label">Image:</label>
                                                    <section className="text-center form-control w-full">
                                                        <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                            {
                                                                (files && files.length == 0) &&
                                                                <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                            }
                                                        </aside>
                                                        <Swiper
                                                            slidesPerView={5}
                                                            scrollbar={{
                                                                hide: true,
                                                            }}
                                                            grid={{
                                                                rows: 1,
                                                            }}
                                                            modules={[Grid, Scrollbar]}
                                                            className="mySwiper h-full"
                                                        >
                                                            {thumbs}
                                                        </Swiper>
                                                        <div {...getRootProps({
                                                            className: 'dropzone p-3'
                                                        })}>
                                                            <input {...getInputProps()} />
                                                            <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                            <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                        </div>
                                                    </section>
                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <label for="signature" className="form-label">Customer Signature <span className="text-theme-6">*</span> :</label>
                                                        <button className="btn btn-outline-secondary mb-2" onClick={clearCanvas}>Clear</button>
                                                    </div>
                                                    <div className="border border-gray-300 rounded-2">
                                                        <SignatureCanvas penColor='black' onEnd={() => getReplaceVehicleSignatureAsBase64()} ref={(ref) => (signatureRef.current = ref)}
                                                            onKeyPress={clearCanvas} canvasProps={{ width: 600, height: 200, className: 'sigCanvas' }} />
                                                    </div>
                                                </div>
                                                <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                                    <button className="btn btn-outline-secondary w-24">Cancel</button>
                                                    <button onClick={saveReplaceVehicleOut} disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                        {
                            activeAccordionItem == 3 || activeAccordionItem == 12 ?
                                <div class="accordion-item box">
                                    <div id="faq-accordion-content-3" class="accordion-header"> <button class={`accordion-button fs-lg ${activeAccordionItem == 3 || activeAccordionItem == 12 ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-7" aria-expanded="false" aria-controls="faq-accordion-collapse-7"> {activeAccordionItem == 3 ? 'Customer Vehicle Info On Pickup' : 'Replaced Vehicle Info On Pickup'}  </button> </div>
                                    <div id="faq-accordion-collapse-7" class={`accordion-collapse collapse ${activeAccordionItem == 3 || activeAccordionItem == 12 ? "show" : ''}`} aria-labelledby="faq-accordion-content-3" data-bs-parent="#faq-accordion-2">
                                        <div class="accordion-body lh-lg">
                                            <div className="grid columns-12">
                                                <div className="intro-y g-col-12 g-col-md-6">
                                                    <label for="km_in" className="form-label">Km In <span className="text-theme-6">*</span> :</label>
                                                    <input id="km_in" name="km_in" value={customerVehicleIn?.km_in} onChange={handleChangeKmIn} type="text" className="form-control" placeholder="Km In" />
                                                    <label for="crud-form-1" className="form-label mt-3">Fuel In <span className="text-theme-6">*</span> :</label>
                                                    <Select styles={styleSelect} className="z-50" value={{ label: customerVehicleIn?.fuel_in, value: customerVehicleIn?.fuel_in }} options={FuelOptions} id="customerVehicleFuelInId" name="customerVehicleFuelIn" onChange={(e) => handleChangeFuelInOption(e)} />
                                                    <label for="image" className="form-label">Image:</label>
                                                    <section className="text-center form-control w-full">
                                                        <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                            {
                                                                (files && files.length == 0) &&
                                                                <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                            }
                                                        </aside>
                                                        <Swiper
                                                            slidesPerView={5}
                                                            scrollbar={{
                                                                hide: true,
                                                            }}
                                                            grid={{
                                                                rows: 1,
                                                            }}
                                                            modules={[Grid, Scrollbar]}
                                                            className="mySwiper h-full"
                                                        >
                                                            {thumbs}
                                                        </Swiper>
                                                        <div {...getRootProps({
                                                            className: 'dropzone p-3'
                                                        })}>
                                                            <input {...getInputProps()} />
                                                            <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                            <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                        </div>
                                                    </section>
                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <label for="signature" className="form-label">Customer Signature <span className="text-theme-6">*</span> :</label>
                                                        <button className="btn btn-outline-secondary mb-2" onClick={clearCanvas}>Clear</button>
                                                    </div>
                                                    <div className="border border-gray-300 rounded-2">
                                                        <SignatureCanvas penColor='black' onEnd={() => getCustomerVehicleSignatureAsBase64()} ref={(ref) => (signatureRef.current = ref)}
                                                            canvasProps={{ width: 600, height: 200, className: 'sigCanvas' }} />
                                                    </div>
                                                </div>
                                                <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                                    <button className="btn btn-outline-secondary w-24">Cancel</button>
                                                    <button onClick={saveCustomerVehicleIn} disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                        {
                            activeAccordionItem == 4 || activeAccordionItem == 13 ?
                                <div class="accordion-item box">
                                    <div id="faq-accordion-content-4" class="accordion-header"> <button class={`accordion-button fs-lg ${activeAccordionItem == 4 || activeAccordionItem == 13 ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-8" aria-expanded="false" aria-controls="faq-accordion-collapse-8"> {activeAccordionItem == 4 ? 'Customer Vehicle Info On Reaching Garage' : 'Replaced Vehicle Info On Reaching Garage'}  </button> </div>
                                    <div id="faq-accordion-collapse-8" class={`accordion-collapse collapse ${activeAccordionItem == 4 || activeAccordionItem == 13 ? "show" : ''}`} aria-labelledby="faq-accordion-content-4" data-bs-parent="#faq-accordion-2">
                                        <div class="accordion-body lh-lg">
                                            <div className="grid columns-12">
                                                <div className="intro-y g-col-12 g-col-md-6">
                                                    <label for="km_out" className="form-label">Km Out <span className="text-theme-6">*</span> :</label>
                                                    <input id="km_out" name="km_out" value={customerVehicleOut?.km_out} onChange={handleChangeKmOut} type="text" className="form-control" placeholder="Km Out" />
                                                    <label for="crud-form-1" className="form-label mt-3">Fuel Out <span className="text-theme-6">*</span> :</label>
                                                    <Select styles={styleSelect} value={{ label: customerVehicleOut?.fuel_out, value: customerVehicleOut?.fuel_out }} options={FuelOptions} id="customerVehicleFuelOutId" name="customerVehicleFuelOut" onChange={(e) => handleChangeFuelOutOption(e)} />
                                                </div>
                                                <div className="intro-y g-col-12 g-col-sm-6">
                                                    <label for="image" className="form-label">Image:</label>
                                                    <section className="container text-center form-control">
                                                        <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                            {
                                                                (files && files.length == 0) &&
                                                                <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                            }
                                                        </aside>
                                                        <Swiper
                                                            slidesPerView={6}
                                                            scrollbar={{
                                                                hide: true,
                                                            }}
                                                            grid={{
                                                                rows: 1,
                                                            }}
                                                            modules={[Grid, Scrollbar]}
                                                            className="mySwiper h-full"
                                                        >
                                                            {thumbs}
                                                        </Swiper>
                                                        <div {...getRootProps({ className: 'dropzone' })}>
                                                            <input {...getInputProps()} />
                                                            <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                            <div className="btn btn-primary w-25 mt-5">Upload Photos</div>
                                                        </div>
                                                    </section>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        {/* <div class="d-flex flex-column mt-2">
                                                        <div class="form-check me-2"> <input id="checkbox-switch-4" class="form-check-input" type="checkbox" value="" /> <label class="form-check-label" for="checkbox-switch-4">Spare Wheel</label> </div>
                                                        <div class="form-check me-2 mt-2 mt-sm-0"> <input id="checkbox-switch-5" class="form-check-input" type="checkbox" value="" /> <label class="form-check-label" for="checkbox-switch-5">Job In</label> </div>
                                                    </div> */}
                                                        {/* <div>
                                                            <button className="btn w-48 btn-primary mt-3">Photos</button>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                                    <button className="btn btn-outline-secondary w-24">Cancel</button>
                                                    <button onClick={saveCustomerVehicleOut} disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>
                    <div className="text-end mt-5">
                        <button type="button" onClick={() => {
                            navigate('/driver/vehicles');
                            Toast.fire({
                                icon: 'success',
                                title: 'Job Done!'
                            })
                        }} className="btn btn-primary w-24 me-1">Done</button>
                        {/*  <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button> */}
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}

export default ReplacementForm;